import React from 'react';
import AmortissementsBlock from './AmortissementsBlock';
import VncEvolutionChart from './VncEvolutionChart';

/**
 * Finance — onglet dédié « Amortissements ».
 * Déplacé hors de l'onglet « Crédits » (28/05/2026 v2) — l'amortissement
 * est une mécanique comptable à part entière, distincte des emprunts.
 *
 * Contient :
 *  - Le tableau d'amortissement de la flotte (5 ans linéaire ou 3 ans accéléré)
 *  - Les amortissements des autres CAPEX (Dépôts 20a · Bureau 9a · Logiciels 3a · Site 2a)
 *  - L'impact fiscal pédagogique (cumul depuis le 1er janvier)
 *  - Mini-graphique de projection VNC sur 36 mois (Phase B bonus)
 */
export default function AmortissementsTab() {
  return (
    <div className="space-y-4" data-testid="amortissements-tab">
      <AmortissementsBlock />
      <VncEvolutionChart />
    </div>
  );
}
